// extracted by mini-css-extract-plugin
export var addFeeButton = "_4i-0";
export var priceInput = "_4i-1";
export var priceInputPrefix = "_4i-5";
export var removeFeeButton = "_4i-3";
export var removeFeeButtonIcon = "_4i-2";
export var subtitle = "_4i-4";